import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { authApi, errorMessage } from "@/lib/api";
import { AuthCard, FormError, SubmitButton, authField } from "@/components/admin/AuthCard";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [f, setF] = useState({ next: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? "" : "This reset link is missing its code. Please request a new one.");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 10) { setError("New password must be at least 10 characters"); return; }
    if (f.next !== f.confirm) { setError("Passwords do not match"); return; }
    setBusy(true);
    setError("");
    try {
      await authApi.resetPassword({ token, new_password: f.next });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <AuthCard title="Password updated" subtitle="You can now sign in with your new password." onSubmit={(e) => e.preventDefault()} testId="reset-password-page">
        <p className="mt-6 flex gap-3 rounded-xl bg-[#E6F2EA] p-4 text-sm text-[#1B4332]" data-testid="reset-password-success"><CheckCircle2 className="h-5 w-5 shrink-0" /> All other devices have been signed out.</p>
        <Link to="/admin/login" className="mt-6 flex h-12 items-center justify-center rounded-full bg-[#1B4332] font-semibold text-white" data-testid="reset-password-signin-link">Sign in</Link>
      </AuthCard>
    );
  }

  const input = (k, label) => (
    <label className="mt-4 block text-sm font-medium">{label}
      <input type="password" required autoComplete="new-password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={authField} data-testid={`reset-password-${k}-input`} />
    </label>
  );

  return (
    <AuthCard title="Choose a new password" subtitle="Use at least 10 characters." onSubmit={submit} testId="reset-password-page">
      {input("next", "New password")}
      {input("confirm", "Confirm new password")}
      <FormError error={error} testId="reset-password-error" />
      {error.includes("request a new one") && <Link to="/admin/forgot-password" className="mt-3 block text-sm font-semibold text-[#1B4332]" data-testid="reset-password-request-new">Request a new link</Link>}
      <SubmitButton busy={busy || !token} label="Save new password" busyLabel="Saving…" testId="reset-password-submit" />
    </AuthCard>
  );
}
